import PubSub from 'pubsub-js';

import { ERROR_CODES } from '@/utils/error-handling-service';
export const PUB_SUB_EVENTS = {
	IS_EXTENSION_INSTALLED_STATE_CHANGED: 'IS_EXTENSION_INSTALLED_STATE_CHANGED',
	TOKEN_INVALID: ERROR_CODES.TOKEN_INVALID,
	REFRESH_TOKEN: 'REFRESH_TOKEN',
	TOKEN_LOAD: 'TOKEN_LOAD',
	IS_EXTENSION_SATISFIED_VERSION_STATE_CHANGED: 'IS_EXTENSION_SATISFIED_VERSION_STATE_CHANGED',
};
export default PubSub;
